import axios from "axios";
import { ElLoading, ElMessage } from "element-plus";
import { getToken } from "./cookie";
import store from "../store"

let httpServer = axios.create();

// 加载中处理
let loading;
let startLoading = () => {
  loading = ElLoading.service({
    lock: true,
    text: "加载中……",
    background: "rgba(255, 255, 255, 0.7)",
  });
};
let requestLoadingNums = 0;
let showLoading = () => {
  requestLoadingNums++ === 0 && startLoading();
};

let hideLoading = () => {
  requestLoadingNums > 0 && --requestLoadingNums === 0 && loading.close();
};

// axios默认配置
// console.log("NODE_ENV", process.env.NODE_ENV);
httpServer.defaults.timeout = 15000;
httpServer.defaults.withCredentials = true;
httpServer.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";

httpServer.interceptors.request.use(
  (config) => {
    getToken() && (config.headers["Authorization"] = "Bearer " + getToken());
    // post请求默认带loading，如不需要loading则加notShowLoading: true
    // get请求默认不带loading，如需要加loading则加showLoading: true
    !config.notShowLoading && config.method !== "get" && showLoading();
    config.showLoading && showLoading();
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

httpServer.interceptors.response.use(
  (res) => {
    let data = res.data;
    res.config.method !== "get" && hideLoading();
    res.config.showLoading && hideLoading();
    if (data && data.code === 200) {
      return Promise.resolve(data.data || data);
    } else {
      // 单点登录异常，先退出登录，再跳转授权登录页
      if (data.code === 500 && data.msg === "登录状态已过期") {
        store.commit("SET_SHOWLOGIN", true);
      }
      // 用户状态已失效，做一些处理
      !res.config.notShowMessage && ElMessage.error(data.msg || "");
      return Promise.reject(data);
    }
  },
  (err) => {
    if (
      err &&
      err.config &&
      !err.config.notShowLoading &&
      err.config.method !== "get"
    ) {
      hideLoading();
    }
    err.config.showLoading && hideLoading();
    let msg = "";
    if (err && err.response) {
      const map = new Map([
        [400, "错误请求"],
        [401, "未授权或登录超时，请重新登录"],
        [403, "拒绝访问"],
        [404, "请求错误,未找到该资源"],
        [405, "请求方法未允许"],
        [500, "服务器端出错"],
        [501, "网络未实现"],
        [502, "网关错误"],
        [503, "服务不可用"],
        [504, "网络超时"],
        ["default", `连接错误${status}`],
      ]);
      msg = map.get(err.response.status) || map.get("default");
    } else {
      msg = "连接到服务器失败";
    }
    ElMessage.error(msg);

    return Promise.reject(err.response);
  }
);

let axiosGet = httpServer.get;
httpServer.get = (url, params, config) =>
  axiosGet(url, Object.assign({ params }, config));

export default httpServer;
